export const IndividualReportAccessDenied = () => (
  <p role="alert" className="tw-text-center tw-text-base tw-text-neutral-700 tw-py-10">
    You don&apos;t have permission to view this assessment.
  </p>
);
